export async function encryptValue(plaintext) {
  const base64Key = process.env.REACT_APP_FIELD_ENCRYPTION_KEY;
  try {
    if (!plaintext) return '';

    const rawKey = Uint8Array.from(atob(base64Key), (c) => c.charCodeAt(0));
    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      rawKey,
      { name: 'AES-GCM' },
      false,
      ['encrypt']
    );

    const nonce = window.crypto.getRandomValues(new Uint8Array(12));
    const encodedPlaintext = new TextEncoder().encode(plaintext);

    const encryptedBuffer = await window.crypto.subtle.encrypt(
      { name: 'AES-GCM', iv: nonce },
      cryptoKey,
      encodedPlaintext
    );

    const nonceB64 = btoa(String.fromCharCode(...nonce));
    const ciphertextB64 = btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer)));

    return `${nonceB64}:${ciphertextB64}`;
  } catch (error) {
    console.error('Encryption error:', error);
    return '';
  }
}